<template lang="pug">
	div#header(role="banner")
		.togglemenu(@click="togglemenu")
			span
		nav.nav-holder(role="navigation")
			ul.menu
				li.menu-item(v-for="(item, index) in menu")
					router-link(:to="'/?scrollto='+item.key")
						span(@click="updateMenu(item.key)") {{item.title}}
</template>

<script>
import store from '@/store';
import Vue from 'vue';

export default {
	name: 'Navmain',
	data() {
		return {
			newRoute: null,
			newPath: null
		}
	},
	computed:{
		menu(){
			return store.state.menu;
		}
	},
	methods:{
		togglemenu(e){
			e.preventDefault();
			let body = document.querySelector('#header');
			if (body.classList.contains('is_open')) {
				body.classList.remove('is_open');
			} else {
				body.classList.add('is_open');
			}
		},
		openmenu(e){
			e.preventDefault();
			let body = document.querySelector('#header');
			body.classList.add('is_open');
		},
		closemenu(e){
			if(e) e.preventDefault();
			let body = document.querySelector('#header');
			body.classList.remove('is_open');
		},
		updateMenu(to) {
			// var data = Object.assign({}, this.$route.query);
			// data['scrollto'] = query;
			let anchor = document.querySelector('#'+to) || null;
			if (anchor) this.$parent.winScrollTo(anchor);
			this.$router.push({name: 'Page', query : { scrollto: to }});
			this.closemenu();
		},
		initStickyMenu: function() {
			var $_header = this.$el,
					_topP = $_header.offsetTop,
					_scrollTop = _topP + $_header.offsetHeight,
					_scrollOuter = _scrollTop * 2,
					_scrolled = _scrollOuter * 2;

			window._isScrolled = {};
			window._isScrolled.one = false;
			window._isScrolled.two = false;
			window._isScrolled.three = false;

			let ifStickyHasClass = (item, classname, add = 'add') => {
				if(add === 'remove'){
					if(item.classList.contains(classname)) {
						item.classList.remove(classname);
					}
				} else {
					if(!item.classList.contains(classname)) {
						item.classList.add(classname);
					}
				}
			};

			let initStickyStatus = (sTop, pOuter, pScrolled) => {
				let _scrollY = window.pageYOffset || document.documentElement.scrollTop;

				if ( _scrollY > sTop && !window._isScrolled.one ) {
					ifStickyHasClass($_header, 'fixed');
					window._isScrolled.one = true;
				}
				if ( _scrollY > pOuter && !window._isScrolled.two ) {
					ifStickyHasClass($_header, 'sticky-menu');
					window._isScrolled.two = true;
				}
				if ( _scrollY > pScrolled && !window._isScrolled.three ) {
					ifStickyHasClass($_header, 'scrolled');
					window._isScrolled.three = true;
				}

				if ( _scrollY < pScrolled && window._isScrolled ) {
					ifStickyHasClass($_header, 'scrolled', 'remove');
					window._isScrolled.three = false;
				}
				if ( _scrollY < pOuter && window._isScrolled ) {
					ifStickyHasClass($_header, 'sticky-menu', 'remove');
					window._isScrolled.two = false;
				}
				if ( _scrollY < sTop && window._isScrolled ) {
					ifStickyHasClass($_header, 'fixed', 'remove');
					window._isScrolled.one = false;
				}
			};

			initStickyStatus(_scrollTop, _scrollOuter, _scrolled);
			window.addEventListener('scroll', () => {
				initStickyStatus(_scrollTop, _scrollOuter, _scrolled);
			});
		}
	},
	mounted() {
		this.initStickyMenu();
	}
}
</script>



// WEBPACK FOOTER //
// src/components/features/Navmain/index.vue